import { SprinklesElement } from "sprinkles-js";

const HEX_RE = /^#([0-9a-f]{3}){1,2}$/i;

export default class ColorInputElement extends SprinklesElement {
  static tagName = "color-input";
  static refs = ["preview", "combobox"];
  static events = {
    change: { method: "handlePreviewChange", ref: "preview" },
    "combobox:change": { method: "syncPreview", ref: "combobox" },
    input: { method: "syncPreview", ref: "combobox" },
  };

  afterConnected() {
    this.syncPreview();
  }

  // Native color picker → mirror its value into the combobox via its public API.
  handlePreviewChange() {
    this.refs.combobox.value = this.refs.preview.value;
  }

  // Combobox value changed (typing or selection) → sync the swatch.
  syncPreview() {
    const value = this.refs.combobox.value;
    if (HEX_RE.test(value)) this.refs.preview.value = value;
  }
}
